<template>
    <div id="newReturnMater">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
        </el-row>
        <el-col class="fl searthPart">
            <!-- <p class="headerT">退料信息</p> -->
            <el-form ref="returnForm" :model="returnForm" :inline="true" label-width="80px" :label-position="labelPosition">
                <el-form-item label="退料类型:">
                    <el-select disabled v-model="returnForm.returnType" placeholder="请选择退料类型" style="width: 100%;">
                        <el-option v-for="(item,index) in pickingTypeList" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="残值类型:" label-width="80px" v-if="returnForm.returnType == 2">
                    <el-select disabled clearable v-model="returnForm.residualType" style="width: 100%;"  placeholder="请选择残值类型" @change="selectResidualType">
                        <el-option v-for="(item,index) in residualTypeList" :key="index" :label="item.paraName" :value="item.paraValue">{{item.paraName}}</el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr">
            <usualNewReturn v-if="returnForm.returnType == 1" :returnForm="returnForm"></usualNewReturn>
            <residualNewReturn  v-if="returnForm.returnType == 2" :returnForm="returnForm"></residualNewReturn>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        wasteTreasureType,
        queryMaterialBySerialNumber,
        returnMaterialAdd,
        selectParameterInfoBusiness
    } from "../../api/api";
    import usualNewReturn from '@/components/eidtReturnManage/usualNewReturn'
    import residualNewReturn from '@/components/eidtReturnManage/residualNewReturn'
    
    export default {
        name: 'newReturnMater',
        components: {
            usualNewReturn,
            residualNewReturn
        },
        data () {
            return {
                labelPosition:'left',
                returnForm:{
                    returnType:1,       //退料类型
                    residualType:'',     //残值类型
                    residualTypeName:'', //残值名称
                    number:'',           //序列号
                    sum:'',
                    amount:'',
                    status:'YQR'
                },
                pickingTypeList:[
                    {
                        paraName:'普通退料',
                        paraCode:1
                    },
                    {
                        paraName:'残值退料',
                        paraCode:2
                    }
                ],
                residualTypeList:[],
                returnData: []
            }
        },
        created(){
            this.$destroy();
            this.getResidualTypeList(); //残值类型
        },
        methods: {
            //残值类型
            getResidualTypeList(){
                let para = {
                    paraType:'residual_type'
                };
                selectParameterInfoBusiness(para).then(res => {
                    if (res.data.status==100) {
                        this.residualTypeList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //modelForm选择残值类型
            selectResidualType(e){
                this.residualTypeList.forEach((item,index)=>{
                    if(item.paraValue == e){
                        this.returnForm.residualTypeName = item.paraName;
                    }
                })
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/returnMaterManageList'
                })
            }
        },
        computed: {
        },
        watch: {
          
        }
    }
</script>

<style type="text/css" lang="scss" scoped>
    #newReturnMater{
        font-size: 14px;
        .searthPart{
            .el-input{
                width: 100%;
            }
        }
        .headerT{
            font-size: 16px;
            margin:0 0 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// editReturnMater.vue?758b1dda